
export const CUSTOM_METRICS = {
  BusinessTimesUpdateSuccess: {
    KEY: 'BAppShopSettingBusinessTimesUpdateSuccess',
  },
  BusinessTimesUpdateNum: {
    KEY: 'BAppShopSettingBusinessTimesUpdateNum',
  },
  SpecialTimesUpdateNum: {
    KEY: 'BAppShopSettingSpecialTimesUpdateNum',
  },
  SpecialTimesUpdateSuccess: {
    KEY: 'BAppShopSettingSpecialTimesUpdateSuccess',
  },
  JumpSunccess: {
    KEY: 'BAppShopSettingJumpSunccess',
  },
  JumpNum: {
    KEY: 'BAppShopSettingJumpNum',
  },
  Crash: {
    KEY: 'BAppShopSettingCrash',
  },
  SelectHolidayDuration: {
    KEY: 'chooseHolidayDuration',
  },
}

export const LvPoint = {
  'cid': {
    Index_BusinessTime: 'c_sailor_b_kssrgkoe',
    Index_SpecialTime: 'c_sailor_b_dhwbyoc0',
    BusinessTimeSet: 'c_sailor_b_igecy01l',
    SpecialTimeSet: 'c_sailor_b_1kuoo9e8',
    SpecialTimeSetPC: 'c_sailor_b_pcu51dmj',
  },
  'bid': {
    BusinessTime: 'b_sailor_b_t3uef9on_mc',
    SpecialTime: 'b_sailor_b_6mr9cwbu_mc',
    ShopStatusSet: 'b_sailor_b_ufgm91ty_mc',
    BusinessTimeSet: 'b_sailor_b_1lns0g59_mc',
    SpecialTimeSet: 'b_sailor_b_yxpquqoe_mc',
    BusinessTimeSetCancel: 'b_sailor_b_uol5ikq6_mc',
    BusinessTimeSetSubmit: 'b_sailor_b_yw5bhsp5_mc',
    SpecialTimeSetSelectHoliday: 'b_sailor_b_vcxg3zfd_mc',
    SpecialTimeSetCancel: 'b_sailor_b_7witltpo_mc',
    SpecialTimeSetSubmit: 'b_sailor_b_9vwl7mfu_mc',
    SpecialHolidaySelect: 'b_sailor_b_97nvyx2m_mc',
    SpecialHolidayConfirm: 'b_sailor_b_75jhm4rx_mc',
    SpecialHolidaySelectPC: 'b_sailor_b_u1xraxg9_mc',
    SpecialHolidayConfirmPC: 'b_sailor_b_ir1ibm08_mc',
  },
}

export const DEFAULT_HOURS_DATA = {
  mon: [{
    'startTime': 0,
    'endTime': 86400,
  }],
  tue: [{
    'startTime': 0,
    'endTime': 86400,
  }],
  wed: [{
    'startTime': 0,
    'endTime': 86400,
  }],
  thu: [{
    'startTime': 0,
    'endTime': 86400,
  }],
  fri: [{
    'startTime': 0,
    'endTime': 86400,
  }],
  sat: [{
    'startTime': 0,
    'endTime': 86400,
  }],
  sun: [{
    'startTime': 0,
    'endTime': 86400,
  }],
}